import { Layout } from '@/components/Layout/Layout.js';
import { RecommendationStack } from '@/components/RecommendationStack/RecommendationStack.js';
import { Body } from '@/components/Typography/Body.js';
import { useUserProfile } from '@/hooks/useUserProfile.js';
import { styled } from '@/stitches/index.js';

const Divider = styled('span', {
  backgroundColor: '$defaultFont',
  height: '$28',
  width: '$1',
});

const RecommendationContainer = styled('span', {
  alignItems: 'center',
  display: 'inline-flex',
  gap: '$8',
});

export const Endorsements = () => {
  const userProfile = useUserProfile();
  const hasRecommendations = (userProfile?.userReviews.count ?? 0) > 0;
  const shouldShowDivider = hasRecommendations && userProfile?.isTopIndependent;

  if (!hasRecommendations) {
    return null;
  }

  return (
    <Layout.FlexRow
      css={{
        alignItems: 'center',
        gap: '$16',
      }}
    >
      {shouldShowDivider && <Divider />}
      {hasRecommendations && (
        <RecommendationContainer
          as="a"
          href="#recommendations"
        >
          <Body
            css={{
              fontSize: '$20',
            }}
          >
            Recommended by{' '}
          </Body>
          <RecommendationStack />
        </RecommendationContainer>
      )}
    </Layout.FlexRow>
  );
};
